import { Avatar as AvatarPrimitive } from '@base-ui/react/avatar'
import { cn } from '@/lib/utils'

function Avatar({
    className,
    size = 'default',
    ...props
}: AvatarPrimitive.Root.Props & {
    size?: 'default' | 'sm' | 'lg'
}) {
    return (
        <AvatarPrimitive.Root
            data-slot='avatar'
            data-size={size}
            className={cn(
                'group/avatar relative flex size-8 shrink-0 rounded-full select-none data-[size=lg]:size-10 data-[size=sm]:size-6',
                className
            )}
            {...props}
        />
    )
}

function AvatarImage({ className, ...props }: AvatarPrimitive.Image.Props) {
    return (
        <AvatarPrimitive.Image
            data-slot='avatar-image'
            className={cn('aspect-square size-full rounded-full object-cover', className)}
            {...props}
        />
    )
}

function AvatarFallback({ className, ...props }: AvatarPrimitive.Fallback.Props) {
    return (
        <AvatarPrimitive.Fallback
            data-slot='avatar-fallback'
            className={cn(
                'flex size-full items-center justify-center rounded-full bg-primary/10 text-sm font-semibold text-primary group-data-[size=sm]/avatar:text-xs',
                className
            )}
            {...props}
        />
    )
}

export { Avatar, AvatarImage, AvatarFallback }
